import { render, staticRenderFns } from "./FormChangePasswordSso.vue?vue&type=template&id=ab15d3e4"
import script from "./FormChangePasswordSso.vue?vue&type=script&lang=js"
export * from "./FormChangePasswordSso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports